import type { DimensionSide, DimensionType, ExportImageOptions } from "./export-image"

export type ExportResizeOptions = Pick<
	ExportImageOptions,
	"resizeHeight" | "resizeWidth" | "resizeMode"
>

export const getExportResizeOptions = (
	dimensionType: DimensionType,
	dimensionSide: DimensionSide,
	dimension: number,
): ExportResizeOptions => {
	if (dimensionType !== "Custom") {
		return {}
	}

	return {
		resizeHeight: dimension,
		resizeWidth: dimension,
		resizeMode: dimensionSide === "Long side" ? "fit" : "fill",
	}
}
